const getAmountAfterFeeReserve = (amount: bigint, fee: bigint): bigint => {
  return amount > fee ? amount - fee : 0n
}

const getAmountAfterFeeSync = ({
  currentAmount,
  totalAmount,
  fee,
  reservedFee,
  shouldReserveFee,
  isMaxAmountSelected
}: {
  currentAmount: bigint
  totalAmount: bigint
  fee: bigint
  reservedFee?: bigint
  shouldReserveFee: boolean
  isMaxAmountSelected: boolean
}): bigint => {
  const feeToReserve = reservedFee && reservedFee > fee ? reservedFee : fee
  const maxTransferableAmount = shouldReserveFee
    ? getAmountAfterFeeReserve(totalAmount, feeToReserve)
    : totalAmount

  if (isMaxAmountSelected) return maxTransferableAmount
  if (!shouldReserveFee) return currentAmount

  // The fee alone eats up the whole balance, so there is nothing to reserve
  // from. Clamping to zero here would silently wipe the amount the user typed
  // and surface a misleading "The amount must be greater than 0" error, so we
  // keep the input and let the validation report the real problem instead.
  if (maxTransferableAmount === 0n) return currentAmount

  return currentAmount > maxTransferableAmount ? maxTransferableAmount : currentAmount
}

/**
 * Removes any extra decimals from the amount.
 * @example getSanitizedAmount('1.123456', 2) => '1.12'
 */
const getSanitizedAmount = (amount: string, decimals: number): string => {
  const sanitizedAmount = amount.split('.')

  if (sanitizedAmount[1]) sanitizedAmount[1] = sanitizedAmount[1].slice(0, decimals)

  return sanitizedAmount.join('.')
}

export { getAmountAfterFeeReserve, getAmountAfterFeeSync, getSanitizedAmount }
